import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { Errors, validationType } from '../../core/model/error.model';
import { AddHolder } from '../../core/model/holder.model';
import { CommonService } from '../../services/common/common.service';
import { HolderService } from '../../services/holder/holder.service';
import { TopUpService } from '../../services/topup/topup.service';
import { ApplicationService } from '../../services/application/application.service';
import { OopsModalComponent } from '../oops-modal/oops-modal.component';
import { formatDate } from '@angular/common';
import { UserService } from '../../services/user/user.service';
import { parse } from 'path';
import { DropdownService } from '../../services/dropdown/dropdown.service';
import { User } from 'src/app/core/model/user.model';

@Component({
  selector: 'app-add-download-offline',
  templateUrl: './add-download-offline.component.html',
  styleUrls: ['./add-download-offline.component.scss'],
})
export class AddDownloadOfflineComponent implements OnInit {
  @Input() applicationDetails: any;
  holderForm: FormGroup;
  error = Errors;
  showLoader = false;
  headerText = ''; //HEADER_TEXT_PANCHECK;
  messageText = ''; //MESSAGE_TEXT_PANCHECK;
  todayDate = new Date();
  application: any;
  applicantUuid: string;
  version: string;
  parentFund: any;
  caList: any = [];
  showValidation = false;
  showDraftValidation = false;
  isOnSubmit = true;
  isOnSuccess = false;
  showversion = false;
  fundDropdownDisable = false;
  showAffiliateValidation = false;
  showInvestorType = true;
  @Input() applicationUuid: string;
  @Output() add: EventEmitter<any> = new EventEmitter();

  distributorEntityName: string = '';
  fundMaster: Array<any> = [];

  constructor(
    private modalController: ModalController,
    private holderService: HolderService,
    private loadingController: LoadingController,
    private commonService: CommonService,
    private toastController: ToastController,
    private applicationService: ApplicationService,
    private topupService: TopUpService,
    private route: ActivatedRoute,
    private userService: UserService,
    private readonly router: Router,
    private readonly dropdownService: DropdownService,

  ) { }

  ngOnInit() {
    this.createForm();
    console.log('Hii Inside add applicant');
    this.getDropDownValues()
    this.getCA_Master();
    //console.log('Hii',this.applicationUuid);
  }

  get form() {
    return this.holderForm.controls;
  }

  createForm() {
    this.holderForm = new FormGroup({
      fundName: new FormControl('', [Validators.required]),
      typeOfInvestor: new FormControl('Individual'),
      typeOfApplication: new FormControl('New'),
    });
  }

  dismissModal() {
    this.modalController.dismiss();
  }


  getDropDownValues() {

    this.dropdownService
      .getChildFund('O')
      // .getChildFund(this.form.fundName.value.fundID)
      .subscribe(
        async (res: any) => {

          this.fundMaster = res;

          const user = await this.userService.getUser().toPromise<any>() as User;
          this.distributorEntityName = user.distributorEntityName;

          if (this.distributorEntityName.includes('Nuvama') || this.distributorEntityName === 'Spark PWM Private Limited') {
            this.parentFund = this.fundMaster.filter(x => x.fundId !== 'FUND369');
          } else {
            this.parentFund = this.fundMaster;
          }

          //this.parentFund=this.parentFund.filter(x=> x.fundId=="FUND252"  || x.fundId == "FUND255"|| x.fundId == "FUND241" || x.fundId == "FUND239" || x.fundId == "FUND261" || x.fundId == "FUND343" || x.fundId == "FUND360" || x.fundId == "FUND368"  || x.fundId == "FUND369"   || x.fundId == "FUND370"  );
          // this.parentFund = this.parentFund.filter(x=> x.fundId=="FUND252"  || x.fundId == "FUND255" || x.fundId == "FUND261" || x.fundId == "FUND360" || );
        },
        (err) => { }
      );
  }


  // downloadOffline(){

  // var childfundid="FUND239";
  // var typeOfInvestor="Individual";

  //    this.applicationService.downloadOfflineCA(childfundid,typeOfInvestor).subscribe(
  //     async (res: any) => {
  //     //    this.commonService.updateLoader(false);
  //      console.log(res);
  // if(res.success){
  //   var urlRs=res.message;

  //       var a = document.createElement('a');
  //        a.href = urlRs; a.target = '_blank';
  //        a.download = res.data;
  //        document.body.appendChild(a);
  //         a.click();
  // }

  //      },
  //      async (err) => {
  //        console.log("Affiliate     ", err);
  //        const toast = await this.toastController.create({
  //          message:  "File not present",
  //          duration: 2000,
  //        });
  //        toast.present();
  //        this.commonService.updateLoader(false);
  //      }
  //    );

  // }



  async getCA_Master() {


    this.applicationService.getCA_Master().subscribe(
      async (res: any) => {
        //    this.commonService.updateLoader(false);
        console.log(res);
        if (res.success) {
          this.caList = res.data;
        }

      },
      async (err) => {

        const toast = await this.toastController.create({
          message: "Error Occurred",
          duration: 2000,
        });
        toast.present();
        this.commonService.updateLoader(false);
      }
    );

  }


  onTypeOfApplication(event) {
    this.showInvestorType = true;
    var calistData;
    var childfundID = this.form.fundName.value.fundId;

    var typeOfApplication = this.form.typeOfApplication.value;

    if (typeOfApplication === 'Transfer') {
      this.parentFund = this.fundMaster;
    } else {

      if (this.distributorEntityName.includes('Nuvama') || this.distributorEntityName === 'Spark PWM Private Limited') {
        this.parentFund = this.fundMaster.filter(x => x.fundId !== 'FUND369');
      }

    }

    if (["New", 'Transfer'].includes(typeOfApplication)) {
      this.showInvestorType = true;
    }
    else {
      this.showInvestorType = false;

    }

    this.onTypeOfInvestor(event);

  }


  onTypeOfInvestor(event) {
    var childfundID = this.form.fundName.value.fundId;
    var typeOfInvestor = this.form.typeOfInvestor.value;
    var calistData;
    if (childfundID == "" || childfundID == undefined || childfundID == null) {
      return;
    }
    else {
      this.onSelectionChange(event);
    }
  }
  onSelectionChange(event) {
    var childfundID = this.form.fundName.value.fundId;
    var typeOfInvestor = this.form.typeOfInvestor.value;
    var calistData;
    this.showversion = true;
    var typeOfApplication = this.form.typeOfApplication.value;
    if (typeOfApplication == "New") {
      if (typeOfInvestor == "Individual") {
        calistData = this.caList.filter(x => x.childFundId == childfundID && x.forIndividual == 1 && x.isAffiliate == 0 && x.isTopUp == 0 && (x.endDate == "" || x.endDate == null) && x.isTransfer == 0);
        this.version = calistData[0].version;
      }
      else {
        calistData = this.caList.filter(x => x.childFundId == childfundID);
        calistData = this.caList.filter(x => x.childFundId == childfundID && x.forIndividual == 0 && x.isAffiliate == 0 && x.isTopUp == 0 && (x.endDate == "" || x.endDate == null) && x.isTransfer == 0);
        this.version = calistData[0].version;
      }
    }
    else if (typeOfApplication == "Top-up") {
      calistData = this.caList.filter(x => x.childFundId == childfundID && x.isTopUp == 1 && (x.endDate == "" || x.endDate == null) && x.isTransfer == 0);
      this.version = calistData[0].version;
    }
    else {
      calistData = this.caList.filter(x => x.childFundId == childfundID && x.isAffiliate == 1 && (x.endDate == "" || x.endDate == null) && x.isTransfer == 0);
      this.version = calistData[0].version;
    }

  }



  async submit() {

    const childfundID = this.form.fundName.value.fundId;
    const typeOfInvestor = this.form.typeOfInvestor.value;
    const typeOfApplication = this.form.typeOfApplication.value;

    if (!childfundID) {
      return;
    }

    this.showLoader = true;
    this.applicationService.downloadOfflineCA(childfundID, typeOfInvestor, typeOfApplication).subscribe(
      async (res: any) => {
        this.showLoader = false;
        if (res.success) {
          const urlRs = res.message;

          const a = document.createElement('a');
          a.href = urlRs;
          a.target = '_blank';
          a.download = res.data;
          document.body.appendChild(a);
          a.click();
        }
      },
      async (err) => {
        this.showLoader = false;
      }
    );
  }

  async downloadDueDiligence() {
    var typeOfInvestor = this.form.typeOfInvestor.value;
    if (!typeOfInvestor) {
      const toast = await this.toastController.create({
        message: 'Please select the type of investor Individual or Non-Individual',
        duration: 3000,
      });
      toast.present();
      return;
    }

    const doc = await this.applicationService.downloadDueDiligence(typeOfInvestor).toPromise<any>();
    const a = document.createElement('a');
    a.href = doc.message;
    a.target = '_blank';
    a.download = doc.message;
    document.body.appendChild(a);
    a.click();
  }

  onCancel() {
    this.showValidation = false
    this.showDraftValidation = false
    this.isOnSubmit = true
    this.isOnSuccess = false
    this.fundDropdownDisable = false
  }


}
